<div class="box-bid">
  <div class="box-header" [ngClass]="{'small-pad': isListCard}" *ngIf="!isFastQuote">
    <div class="row">
      <div class="col-md-12">
        <div class="title-box">
          <i class="app-icon-tag" style="margin-right: 8px;"></i>
          VALOR ATUAL PARA OFERTA
        </div>
      </div>
      <div class="col-md-12 value">
        <mat-form-field>
          <span matPrefix class="currency-symbol">R$&nbsp;</span>
          <input matInput currencyMask [options]="{ prefix: '', thousands: '.', precision: 0, allowNegative: false }"
            type="tel" [(ngModel)]="bidValue" (click)="$event.stopPropagation();" disabled>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="buy-now">
          <div class="label">
            <i class="app-icon-new-arramatar" style="margin-right: 8px;"></i>
            PREÇO COMPRAR AGORA
          </div>
          <div class="value">
            <span class="currency-symbol">R$ </span>
            {{vehicle.finishValue | number}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="box-body" [ngClass]="{'small-pad': isListCard}">
    <div class="info" *ngIf="info">
      <h3 class="box-title">{{info.title}}</h3>
      <p>{{info.text}}</p>
    </div>
    <button (click)="requestJoinGroup()" class="btn btn-branded1" *ngIf="showRequestBtn" [ngClass]="{'disabled': vehicle.pendingExclusiveDealer}">{{btnLabel}}</button>
    <!-- <a (click)="openModal()" class="terms" *ngIf="!vehicle.pendingExclusiveDealer">Confira os termos de adesão ao grupo</a> -->
  </div>
</div>
<div class="modal-backdrop fade in" [style.display]="showModal ? 'block' : 'none'"></div>
<div class="modal fade" [style.display]="showModal ? 'block' : 'none'" [ngClass]="{'show': showModal, 'hide': !showModal}"  *ngIf="user && user.isDealer()" (click)="closeModal()">]
  <div class="modal-dialog modal-dialog-centered" (click)="false; $event.stopPropagation();">
    <div class="modal-content box-modal-bid">
      <div class="modal-header">
        <div class="modal-title">
          Termos de adesão aos grupos exclusivos
        </div>
      </div>
      <div class="modal-body">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia vel enim velit id, tempora recusandae! Adipisci accusantium eos, laboriosam fugit repudiandae, molestiae qui modi, repellendus dolores harum cum quisquam neque?
      </div>
    </div>
</div>
